/* eslint no-unused-vars: "off" */
/* eslint no-undef: "off" */


function loadLang(){

	var lang = {
			'confirm':{
				'lt' : 'Taip',
				'en'   : 'Yes',
			},
			'andContinue':{
				'lt' : 'ir tęsti',
				'en'   : 'and continue',
			},
			'select':{
				'lt' : 'Pasirinkite',
				'en'   : 'Select',
			},
			'cancel'   : {
				'lt'   : 'Atšaukti',
				'en'   : 'Cancel',
			},
			'delete'   : {
				'lt'   : 'Ištrinti',
				'en'   : 'Delete'
			},
			'deleteRecord':{
				'lt' : 'Trinti įrašą?',
				'en'   : 'Delete record?',
			},
			'deleteRecordMsg':{
				'lt' : '',
				'en'   : '',
			},
			'yes'   : {
				'lt'   : 'Taip',
				'en'   : 'Yes'
			},
			'no'   : {
				'lt'   : 'Ne',
				'en'   : 'No'
			},
			'uploadImage':{
				'lt' : 'Įkelti nuotrauką...	',
				'en'   : 'Upload image',
			},
			'save':{
				'lt' : 'Išsaugoti	',
				'en'   : 'Save',
			},
			'noRecords':{
				'lt' : 'Įrašų nėra',
				'en'   : 'There are no records',
			},
			'noRecords_note':{
				'lt' : 'Pagal jūsų paieškos kriterijus - įrašų nėra.',
				'en'   : 'There are no records for your search criterion.',
			},
			'noData':{
				'lt' : 'Duomenų nėra',
				'en'   : 'There is no data',
			},
			'noData_note':{
				'lt' : 'Duomenų nėra',
				'en'   : 'There is no data for your search criterion.',
			},
			'attention':{
				'lt' : 'Dėmesio',
				'en'   : 'Attention',
			},
			'attention_file_delete':{
				'lt' : 'Ar tikrai pašalinti šį failą',
				'en'   : 'Do you realy want to delete this file',
			},
			'list':{
				'lt' : 'Sąrašas',
				'en'   : 'List',
			},
			'today':{
				'lt' : 'Šiandien',
				'en'   : 'Today',
			},
			'day':{
				'lt' : 'Diena',
				'en'   : 'Day',
			},
			'customRange':{
				'lt' : 'Rankinis pasirinkimas',
				'en'   : 'Custom Range',
			},

		},
		new_arr = {};

	$.each(lang, function(index, value) {
		new_arr[index] = value[locale];
	});

	return new_arr;

}
var lang = loadLang();